import React from 'react';
import { useHotjarWidget } from '../hooks/useHotjarWidget';
import { useLocation } from 'react-router-dom';

interface HotjarProviderProps {
  children: React.ReactNode;
}

export const HotjarProvider: React.FC<HotjarProviderProps> = ({ children }) => {
  const location = useLocation();

  // Define as rotas onde o Hotjar não deve aparecer
  const excludedPaths = ['/', '/login_router_callback', '/sign_out'];
  const shouldShowHotjar = !excludedPaths.includes(location.pathname);

  // Inicializa o widget do Hotjar apenas se não estiver em rotas de login
  useHotjarWidget(shouldShowHotjar);

  return <>{children}</>;
};

export default HotjarProvider;
